.file-upload-btn{margin-top:2rem;--border-color: #2196f3;--color: #2196f3;--border-width: 1px;text-transform:none;--border-radius: 5px;height:35px}
/*# sourceMappingURL=file-upload-button.component-EBZC4OR2.css.map */
